/*
 * @Author: caizexin caizexin@kjgb.net
 * @Date: 2023-05-18 14:07:05 
 * @Msg: 获取当前日期，及当前日期在全年中是第几周
 * @dateNow是当前日期 
 * @dateFirst是当年第一天  
 * @dataNumber是当前日期是今年第多少天  
 * @用dataNumber + 当前年的第一天的周差距的和在除以7就是本年第几周  
 */

import { ref } from 'vue';

export function getWeek(){
    const week = ref()
    const currentDate = ref()

    const dd = new Date()
    const year = dd.getFullYear()
    const month = dd.getMonth() + 1
    const date = dd.getDate()

    const dateNow = new Date(year, parseInt(month) - 1, date);
    const dateFirst = new Date(year, 0, 1);
    const dataNumber = Math.round((dateNow.valueOf() - dateFirst.valueOf()) / 86400000);

    week.value = Math.ceil((dataNumber + ((dateFirst.getDay() + 1) - 1)) / 7);
    currentDate.value = `${year}/${month}/${date}`

    return{
        week,
        currentDate
    } 
}